import {
  Accessibility,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  ArrowUpRight,
  Bell,
  BellOff,
  Bike,
  Bookmark,
  BusFront,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Check,
  CircleAlert,
  CircleCheckBig,
  CircleArrowRight,
  Clock,
  Compass,
  FileText,
  Footprints,
  GlobeOff,
  Hand,
  Headset,
  Info,
  Languages,
  Layers2,
  Link,
  Mail,
  MapPin,
  MapPinOff,
  MapPinPlus,
  MessageCircleWarning,
  Moon,
  Phone,
  Plus,
  RotateCcw,
  RotateCcwClock,
  Route,
  Rss,
  Search,
  Share2,
  SquareSquare,
  SquareStop,
  TrainFront,
  Trash2,
  TriangleAlert,
  Users,
  X,
  Zap,
  type IconNode,
  Eraser,
  Focus,
  Cog,
} from 'lucide';

/**
 * The glyphs the app uses, keyed by their canonical Lucide name.
 *
 * Listing them explicitly is what keeps the bundle small: only these reach the
 * build, out of Lucide's ~1600 icons. Adding an icon means importing it here.
 */
export const ICONS = {
  accessibility: Accessibility,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up-down': ArrowUpDown,
  'arrow-up-right': ArrowUpRight,
  bell: Bell,
  'bell-off': BellOff,
  bike: Bike,
  bookmark: Bookmark,
  'bus-front': BusFront,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'circle-alert': CircleAlert,
  'circle-check-big': CircleCheckBig,
  eraser: Eraser,
  'circle-arrow-right': CircleArrowRight,
  clock: Clock,
  focus: Focus,
  compass: Compass,
  'file-text': FileText,
  footprints: Footprints,
  'globe-off': GlobeOff,
  hand: Hand,
  headset: Headset,
  info: Info,
  languages: Languages,
  'layers-2': Layers2,
  link: Link,
  mail: Mail,
  'map-pin': MapPin,
  'map-pin-off': MapPinOff,
  'map-pin-plus': MapPinPlus,
  'message-circle-warning': MessageCircleWarning,
  moon: Moon,
  phone: Phone,
  plus: Plus,
  'rotate-ccw': RotateCcw,
  'rotate-ccw-clock': RotateCcwClock,
  route: Route,
  rss: Rss,
  search: Search,
  'share-2': Share2,
  cog: Cog,
  'square-square': SquareSquare,
  'square-stop': SquareStop,
  'train-front': TrainFront,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  users: Users,
  x: X,
  zap: Zap,
} satisfies Record<string, IconNode>;

export type IconName = keyof typeof ICONS;
